import { loadAppConfig } from "@/lib/config";
import type { AppEnv } from "@/lib/config/types";

const appConfig = loadAppConfig(
  import.meta.env.VITE_APP_ENV as AppEnv | "local",
);
const GTM_ID = appConfig.NEXT_PUBLIC_GTM_ID;
const GTM_ENABLED = appConfig.NEXT_PUBLIC_GTM_ENABLED;

const isGTMEnabled =
  typeof window !== "undefined" && !!GTM_ID && GTM_ENABLED === "true";

export const sendEvent = (event: any): void => {
  // Debug: log every GTM event from one place (event name + full payload).

  if (!isGTMEnabled) {
    console.warn("GTM is not enabled or not available");
    return;
  }

  try {
    const win = window as Window & { dataLayer?: unknown[] };
    win.dataLayer = win.dataLayer ?? [];
    win.dataLayer.push(event);
  } catch (error) {
    console.error("Failed to send GTM event:", error);
  }
};
